import React from 'react';
import {CardType} from "../../models/api/codegen/code";
import {useTranslation} from "react-i18next";

export const Label: React.FC<{ card: CardType }> = ({card}) => {
    const {t} = useTranslation();
    return (
        <div className="flex text-[20px] text-[#EACD40]">
            {card.translate ? (card.title && t(card.title)) : card.title}
        </div>
    )
}
